export const RETRY_NUMBER_ATTEMPTS_GET_BALANCE = 3;
